import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const CameroonFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14510'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14510)'>
				<rect
					x='9.52344'
					width='10.4762'
					height='14'
					fill='url(#paint0_linear_2332_14510)'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H6.66667V0H0V14Z'
					fill='#059170'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.66602 14H13.3327V0H6.66602V14Z'
					fill='#E21A30'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M13.334 14H20.0007V0H13.334V14Z'
					fill='#FFDC44'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.0001 7.90996L8.6006 8.88767L9.11697 7.28116L7.73567 6.27892L9.45429 6.26375L10.0001 4.66663L10.5459 6.26375L12.2645 6.27892L10.8832 7.28116L11.3996 8.88767L10.0001 7.90996Z'
					fill='#FFDC42'
				/>
			</g>
			<defs>
				<linearGradient
					id='paint0_linear_2332_14510'
					x1='9.52344'
					y1='0'
					x2='9.52344'
					y2='14'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='#FFDC44' />
					<stop
						offset='1'
						stopColor='#FDD216'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default CameroonFlagIcon;
